import { render, staticRenderFns } from "./bo-dropdown.vue?vue&type=template&id=34fbdc24"
import script from "./bo-dropdown.vue?vue&type=script&lang=js"
export * from "./bo-dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports